<template>
  <div id="app">
    <Background/>
    
    <!-- <TextLayer v-if="VP != null" :content="shows[1].text"/> -->
    <Archive :shows="shows" :isMobile="isMobile" @VP="vpChange"/>
    <!-- <Blog :mobile="mobile"/> -->
  </div>
</template>

<script>
import Archive from './components/Archive.vue'
import Background from './components/Background.vue'
// import TextLayer from './components/TextLayer.vue'
// import Blog from './components/Blog.vue'

export default {
  name: 'App',
  components: {
    Archive, Background
  },
  data() {
    return {
      isMobile: null,
      VP: null,
      shows: [
        {
          number: 1,
          guest: "Mary",
          description: "",
          date: "2018",
          img: "img/showww-23.jpg",
          embedUrl: ["api.soundcloud.com/tracks/502256232"],
          text: null
        },
        {
          number: 2,
          guest: "Look Angle",
          date: "2019",
          img: 'img/showww-30.jpg',
          embedUrl: ["api.soundcloud.com/tracks/562271055"],
          text: null
        },
        {
          number: 3,
          guest: "Mary",
          date: "2019",
          img: "img/Screenshot 2020-12-14 at 18.02.24.jpg",
          embedUrl: ["api.soundcloud.com/tracks/597304437"],
          text: null
        },
        {
          number: 4,
          guest: "Mary",
          description: "(,,∩ ｡ ∩)⊃━♥+ ﾟ . + . ﾟ cool down",
          date: "2019",
          img: "img/Screenshot 2020-12-14 at 18.02.41.jpg",
          embedUrl: ["api.soundcloud.com/tracks/625849956"],
          text: null
        },
        {
          number: 5,
          guest: "Mary & pinkfatbuddha",
          date: "2019",
          description: "__φ(．．) diary writing",
          img: "img/showww-06.jpg",
          embedUrl: ["api.soundcloud.com/tracks/685008187"],
          text: null
        },
        {
          number: 7,
          guest: "Mary & Ajabu",
          date: "2019",
          img: "img/showww_ajabu-01.png",
          embedUrl: ["api.soundcloud.com/tracks/741796930"],
          text: null
        },
        {
          number: 8,
          guest: "OJOO GYAL",
          date: "2019",
          img: "img/OJOO.jpg",
          embedUrl: ["api.soundcloud.com/tracks/760156969"],
          text: null
        },
        {
          number: 9,
          guest: "Mary & mo chuisle",
          date: "2019",
          img: "img/version_mc-08 copy.jpg",
          embedUrl: ["api.soundcloud.com/tracks/773745991", "api.soundcloud.com/tracks/773735191"],
          text: null
        },
        {
          number: 10,
          guest: "Derozan",
          date: "2020",
          img: "img/derozanlighter.jpg",
          embedUrl: ["api.soundcloud.com/tracks/853649143"],
          text: null
        },
        {
          number: 11,
          guest: "lilbigdarko",
          date: "2020",
          img: "img/smalldarko.jpg",
          embedUrl: ["api.soundcloud.com/tracks/911312758"],
          text: null
        },
        {
          number: 12,
          guest: "zhizhi",
          date: "2020",
          description: "Sweet kawaii girl zhizhong visiting",
          img: "img/zhizhi-02.jpg",
          embedUrl: ["api.soundcloud.com/tracks/927570322"],
          text: `All these mixes here a capsules of encounters with myself and people I feel connections with. I love you all dearly and hope one can find pleasure in listening to the journey of present-day music and emotion.`
        }
      ]
    }
  },
  created() {
    this.CheckForMobile();
    window.addEventListener('resize', this.CheckForMobile);
  },
  methods: {
    CheckForMobile() {
      let mobileOS = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (window.innerWidth <= 768 || mobileOS) {
        this.isMobile = true;
      }
      else { 
        this.isMobile = false;
      }
    },
    vpChange(val) {
      this.VP = val;
    }
  }
}
</script>

<style>
html, body {
  width:100%;
  height:100%;
  margin: 0;
  padding:0;
  overflow:hidden;
  box-sizing:border-box;
}

* {
  box-sizing:border-box;
}

#app {
  position:absolute;
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width:100%;
  height:100%;
  margin: 0;
  padding:0;
  top:0;
  color:rgb(0, 0, 0);
}

h1 {
  margin-block-start:5px;
  margin-block-end:5px;
  margin-left:5px;
  line-height:1;
  font-family: connected;
  font-weight:normal;
  font-size:30px;
  /* background-color:white; */
}

a {
  color: #42b983;
}

@font-face {
  font-family: connected;
  src: url(./assets/fonts/connected.ttf);
}
</style>
